import { useEffect } from "react";

import { useDispatchedActions } from "./use-dispatch-actions";

export const useClientAnonymityInfo = () => {
  const { getAnonymityInfo } = useDispatchedActions();

  useEffect(() => {
    getAnonymityInfo();
  }, []);
};
